export enum CardVariantEnum {
  LARGE = 'large',
  MEDIUM = 'medium',
  REGULAR = 'regular',
  SECONDARY_REGULAR = 'secondary-regular',
  SQUARE = 'square',
}

export enum ButtonVariantEnum {
  EXPRESSIVE = 'expressive',
  SECONDARY_WHITE = 'secondary-white',
}
